'use strict';

(function(window) {

  var careersSearch = {
    // Get all careers search forms
    init: function() {
      const careersSearchEl = document.getElementsByClassName('CareersSearch');

      if (!careersSearchEl.length) {
        return;
      }

      this.eachSearch(careersSearchEl);
    },
    // For each search send to careers search site using search value
    eachSearch: function(searches) {
      for (let search of searches) {
        const searchUrl = search.dataset.search;
        const query = search.dataset.query ? `?${search.dataset.query}=` : '';

        search.onsubmit = function(e) {
          const searchVal = search.getElementsByClassName('CareersSearch-input')[0].value;

          if(searchVal && searchUrl) {
            window.open(encodeURI(searchUrl + query + searchVal));
          } else {
            e.preventDefault();
          }

        }
      }
    }
  };

  (function() {
    careersSearch.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/careers-search.js